import { Suspense } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';

import { Footer } from './Footer';
import { Header } from './Header';

function PageSkeleton() {
  return <div className="flex-1 animate-pulse bg-muted/30" />;
}

export function Layout() {
  return (
    <div className="flex min-h-full flex-col">
      <ScrollRestoration />
      <Header />
      <main className="flex-1">
        <Suspense fallback={<PageSkeleton />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
